module.exports = __webpack_public_path__ + "img/no_data.7e8710ba.png";